<template>
  <div :class="optionStyle" ref="option">
    <dl>
      <dt>{{ text }}：</dt>
      <dd>
        <a href="javascript:;" @click="is_show = !is_show">{{ selected_text }}</a>
      </dd>
    </dl>
    <transition name="gas-select">
      <ul v-show="is_show">
        <li
          v-for="(option, index) in options"
          :key="index"
          @click="choice(option)"
        >
          <a href="javascript:;" :value="Object.values(option)[0]">{{
            Object.values(option)[1]
          }}</a>
        </li>
        <!-- class="timeCur" -->
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: "select-lable",
  props: {
    value: [Number, String, Boolean],
    text: String,
    width: Number,
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    optionStyle: {
      type: String,
      default: "sLayer",
    },
    selected_text : String
  },
  data() {
    return {
      is_show: false,
    };
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.option) {
        if (!this.$refs.option.contains(e.target)) {
          this.hide();
        }
      }
    });
    this.selected_text = this.selected_text.length === 0 ? Object.values(this.options[0])[1] : this.selected_text;
  },
  methods: {
    choice(option) {
      this.selected_text = option.text || Object.values(option)[1];
      this.$emit("input", option.value || Object.values(option)[0]);
      this.$emit("reset");
      this.hide();
    },
    hide() {
      this.is_show = false;
    },
  },
};
</script>